import { GENDER } from '../data/define';
import ImgMale1 from '../assets/image/profiles/img_kid_profile_male_1.png';
import ImgMale2 from '../assets/image/profiles/img_kid_profile_male_2.png';
import ImgMale3 from '../assets/image/profiles/img_kid_profile_male_3.png';
import ImgFemale1 from '../assets/image/profiles/img_kid_profile_female_1.png';
import ImgFemale2 from '../assets/image/profiles/img_kid_profile_female_2.png';
import ImgFemale3 from '../assets/image/profiles/img_kid_profile_female_3.png';

type GenderType = typeof GENDER[keyof typeof GENDER];

export default function useRandomProfile() {
  const randomProfile = (gender?: GenderType, number?: number): string => {
    if (number && [1, 2, 3].includes(number)) {
      if (gender === GENDER.MALE) {
        return [ImgMale1, ImgMale2, ImgMale3][number - 1];
      } else if (gender === GENDER.FEMALE) {
        return [ImgFemale1, ImgFemale2, ImgFemale3][number - 1];
      }
    }

    // number가 없거나 gender가 없을 때 랜덤 처리
    if (gender === GENDER.MALE) {
      const profiles = [ImgMale1, ImgMale2, ImgMale3];
      return profiles[Math.floor(Math.random() * profiles.length)];
    } else if (gender === GENDER.FEMALE) {
      const profiles = [ImgFemale1, ImgFemale2, ImgFemale3];
      return profiles[Math.floor(Math.random() * profiles.length)];
    } else {
      const profiles = [ImgMale1, ImgMale2, ImgMale3, ImgFemale1, ImgFemale2, ImgFemale3];
      return profiles[Math.floor(Math.random() * profiles.length)];
    }
  };

  return { randomProfile };
}
